import React from "react";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  return (
    <div className="footer-123">
      <div className="footer-container">
        <div>
          <div className="footer">
            <ul>
              <li
                onClick={() => navigate("/privacy")}
                style={{ cursor: "pointer" }}
              >
                Privacy Policy
              </li>
              <li
                onClick={() => navigate("/contact")}
                style={{ cursor: "pointer" }}
              >
                Contact US
              </li>
              <li>Terms And Condition</li>
              <li>Outstation</li>
              <li>Enterprise</li>
            </ul>
          </div>
          {/* <div className="social">
          <div>
            <IoLogoFacebook size={30}/>
          </div>
          <div> 
            <FaInstagramSquare size={30}/>
          </div>
          <div> 
            <IoLogoLinkedin size={30}/>
          </div>
          <div>
            <FaSquareXTwitter size={30}/>
          </div>
        </div> */}
          <div className="company">
            <h5>SAWBEY MAINTAINIC PVT LTD</h5>
          </div>
          <div className="address">
            <p>
              Copyright 2025 @DriveOme | Powered by: Dexterous Technology. All
              rights reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
